<template>
    <Toast />
    <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
        class="w-[90vw] md:w-[50vw]">
        <div class="flex items-start space-x-3">
            <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
            <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
        </div>
        <template #footer>
            <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
        </template>
    </Dialog>
    <IndexView />
    <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ 'hidden': !isBlur }"></div>
    <ViewContainer>
        <section class="p-6">
            <!-- Container untuk List Meja dan List Order dalam 2 baris -->
            <div class="grid grid-cols-1 gap-6">
                <div v-if="isCashRegisterVisible" class="bg-light-50 dark:bg-dark-800 lg:order-last">
                    <CashRegister @showDialog="showModalDialog" />
                </div>
                <div v-if="isOrderVisible" class="bg-light-50 dark:bg-dark-800 lg:order-last">
                    <div
                        class="border-t-2 border-primary bg-light-50 dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500">
                        <SearchBox v-model="searchOrder" placeholder="Cari Order" class-add="w-full" />
                        <ListOrder :searchOrder="searchOrder" />
                    </div>
                </div>
            </div>
        </section>
    </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import CashRegister from '@/components/card-dashboard/cash-register/CashRegister.vue';
import { Button, Dialog, Toast } from 'primevue';
import ViewContainer from '@/components/ViewContainer.vue';
import ListOrder from './new-transaction/order/ListOrder.vue';
import SearchBox from './new-transaction/SearchBox.vue';

export default {
    name: 'DashboardView',
    components: {
        IndexView, CashRegister, Dialog, Toast, Button, ViewContainer, ListOrder, SearchBox
    },
    computed: {
        isCashRegisterVisible() {
            return localStorage.getItem('role_id') !== "null";
        },
        isOrderVisible() {
            return localStorage.getItem('role_id') !== "null";
        },
    },
    data() {
        return {
            showErrorDialog: false,
            errorMessage: '',
            isBlur: false,
            searchOrder: '',
            tables: [
                { id: 1, name: 'Table 1', status: 'Available' },
                { id: 2, name: 'Table 2', status: 'Occupied' },
                { id: 3, name: 'Table 3', status: 'Available' },
                { id: 4, name: 'Table 4', status: 'Occupied' },
                { id: 5, name: 'Table 5', status: 'Available' },
            ],
        };
    },
    methods: {
        toggleBlur() {
            this.isBlur = !this.isBlur;
        },
        showModalDialog(errors) {
            this.showErrorDialog = true;
            this.errorMessage = errors;
        }
    }
}
</script>